<template>
  <div class="tech-cumulative-chart-container">
    <div class="header-container">
      <div class="header">
        INDIVIDUAL PURCHASE AND INSTALL TARGETS
      </div>
      <div class="filter-container">
        <div class="target-container">
          <button
            @click="toggleTargetPopover(!showTargets)"
          >
            <img
              src="@shared/assets/img/general/goal.svg"
              class="goal-button"
              alt="goals"
            >
          </button>
          <div
            v-if="showTargets"
            class="target-popup-container"
          >
            <div class="plr-20 flex-row align-center">
              <img
                src="@shared/assets/img/adoption/target-black.png"
                alt="Target"
                class="target-icon"
              >
              <div class="sac__font-16 bold detail-black">
                Weekly Target
              </div>
            </div>
            <div
              :class="[
                'tp-body-container',
                focused === 'team' ? 'active' : '',
              ]"
            >
              <input
                v-model="teamCopy"
                :class="['tp-input',
                         focused === 'team' ? 'active' : '']"
                maxlength="2"
                @focus="focused = 'team'"
                @keypress="isNumber"
              >
              <div class="flex-row margin-right-4 margin-left-4">
                <button
                  class="tp-button"
                  @click="saveInstallationTarget('team')"
                >
                  <img
                    v-if="focused === 'team'"
                    src="@shared/assets/img/general/svg/check-white.svg"
                    alt="Save"
                    class="check-icon"
                  >
                  <img
                    v-else-if="teamCopy > 0"
                    src="@shared/assets/img/general/svg/check-black.svg"
                    alt="Save"
                    class="check-icon"
                  >
                </button>
                <button
                  class="tp-button"
                  @click="cancelInstallionTarget('team')"
                >
                  <img
                    v-if="focused === 'team'"
                    src="@shared/assets/img/general/svg/x-white.svg"
                    alt="Cancel"
                    class="x-icon"
                  >
                  <img
                    v-else-if="teamCopy > 0"
                    src="@shared/assets/img/general/svg/x-black.svg"
                    alt="Cancel"
                    class="x-icon"
                  >
                </button>
              </div>
              <div
                :class="[
                  'sac__font-16',
                  'bold',
                  focused === 'team' ? 'f-white' : 'detail-black',
                ]"
              >
                Team Target
              </div>
            </div>
            <div
              :class="[
                'tp-body-container',
                focused === 'individual' ? 'active' : '']"
            >
              <input
                v-model="installationCopy"
                :class="['tp-input',
                         focused === 'individual' ? 'active' : '']"
                maxlength="2"
                @focus="focused = 'individual'"
                @keypress="isNumber"
              />
              <div class="flex-row margin-right-4 margin-left-4">
                <button
                  class="tp-button"
                  @click="saveInstallationTarget('individual')"
                >
                  <img
                    v-if="focused === 'individual'"
                    src="@shared/assets/img/general/svg/check-white.svg"
                    alt="Save"
                    class="check-icon"
                  >
                  <img
                    v-else-if="installationCopy > 0"
                    src="@shared/assets/img/general/svg/check-black.svg"
                    alt="Save"
                    class="check-icon"
                  >
                </button>
                <button
                  class="tp-button"
                  @click="cancelInstallionTarget('individual')"
                >
                  <img
                    v-if="focused === 'individual'"
                    src="@shared/assets/img/general/svg/x-white.svg"
                    alt="Cancel"
                    class="x-icon"
                  >
                  <img
                    v-else-if="installationCopy > 0"
                    src="@shared/assets/img/general/svg/x-black.svg"
                    alt="Cancel"
                    class="x-icon"
                  >
                </button>
              </div>
              <div
                :class="[
                  'sac__font-16',
                  'bold',
                  focused === 'individual' ? 'f-white' : 'detail-black',
                ]"
              >
                Individual Target
              </div>
            </div>
          </div>
        </div>
        <button
          :class="[
            'filter-button',
            activeFilter === '1month' ? 'active' : null,
          ]"
          type="button"
          @click="changeDateFilter('1month')"
        >
          1 month
        </button>
        <button
          :class="[
            'filter-button',
            activeFilter === '3months' ? 'active' : null,
          ]"
          type="button"
          @click="changeDateFilter('3months')"
        >
          3 months
        </button>
        <button
          :class="[
            'filter-button',
            activeFilter === '9months' ? 'active' : null,
          ]"
          type="button"
          @click="changeDateFilter('9months')"
        >
          9 months
        </button>
        <Datepicker
          v-model="dateRange"
          mode="range"
          :max-date="new Date()"
          popover-align="right"
        >
          <template #default>
            <button
              :class="[
                'filter-button',
                activeFilter === 'custom' ? 'active' : null,
              ]"
              type="button"
            >
              <div v-if="activeFilter !== 'custom'">
                Custom
                <img
                  src="@shared/assets/img/general/chevron-grey-down.png"
                  alt="Select"
                  class="button-icon"
                >
              </div>
              <span v-else>
                {{ customRangeHeader }}
              </span>
              <div
                v-if="activeFilter === 'custom' && dateRange.start && dateRange.end"
                class="clear-container"
              >
                <div class="clear-tooltip">
                  Clear Dates
                </div>
                <button
                  class="clear-btn"
                  type="button"
                  @click="clearRangeFilter"
                >
                  <img
                    class="button-icon"
                    src="@shared/assets/img/general/x-white.png"
                    alt="Clear"
                  >
                </button>
              </div>
            </button>
          </template>
        </Datepicker>
      </div>
    </div>
    <div
      v-if="loading"
      class="loading-container"
    >
      <img
        src="@shared/assets/img/general/loading-white.svg"
        alt="Loading"
        class="loader-img"
      >
    </div>
    <highcharts
      v-else
      :options="chartOptions"
    />
    <div
      v-if=" !loading && isThereData"
      class="no-data"
    >
      No Installations during this period
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'v-calendar/lib/components/date-picker.umd';

import technicianMixin from '@shared/mixins/technicianMixin';

import apiClient from '@shared/lib/general/apiClient';

export default {
  name: 'CumulativeBarChart',
  components: {
    Datepicker,
  },
  mixins: [technicianMixin],
  data() {
    return {
      activeFilter: '1month',
      graphHardwareInstallsData: [],
      teamTarget: 0,
      teamCopy: 0,
      focused: '',
      installationTarget: 0,
      installationCopy: 0,
      customRange: {
        start: null,
        end: null,
      },
      loading: false,
      showTargets: false,
    };
  },
  computed: {
    dateRange: {
      get() {
        return this.customRange;
      },
      set(dateRange) {
        if (dateRange && dateRange.start && dateRange.end) {
          this.customRange = dateRange;
          this.activeFilter = 'custom';
          this.getHardwareInstallGraph();
        }
      },
    },
    xAxis() {
      return this.graphHardwareInstallsValues.map(({ date }) => {
        if (typeof date === 'number') {
          return `${date}-01-01`;
        }
        return moment(date).format('M/D');
      });
    },
    chartOptions() {
      return {
        title: '',
        chart: {
          type: 'column',
          backgroundColor: 'transparent',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          backgroundColor: null,
          borderColor: null,
          distance: 32,
          style: {
            fontFamily: 'Poppins',
          },
          shape: 'rect',
          borderRadius: 10,
          formatter() {
            return `<div style="font-weight:bold;color:#000">${this.y}</div>`;
          },
        },

        plotOptions: {
          series: {
            pointWidth: 16,
            groupPadding: 0.4,
            events: {
              mouseOver() {
                this.chart.tooltip.update({
                  backgroundColor: this.color,
                });
              },
            },
          },
          column: {
            stacking: 'normal',
          },
        },
        xAxis: {
          categories: this.xAxis,
          title: {
            text: '',
          },
          labels: {
            style: {
              color: 'white',
              fontFamily: 'Poppins',
            },
          },
          gridLineColor: '#121830',
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            style: {
              color: 'white',
              fontFamily: 'Poppins',
            },
          },
          min: null,
          max: Math.max(
            ...this.hardwareAxis,
            ...this.verifiedAxis,
            ...this.customerPurchasesAxis,
            this.installationTarget,
          ) * 3,
          gridLineColor: '#121830',
          plotLines: this.installationTarget > 0 ? [{
            value: this.installationTarget,
            width: 2,
            dashStyle: 'dash',
            zIndex: 10,
            label: {
              useHTML: true,
              text: this.installationTarget,
              x: -35,
              y: 3,
              style: {
                color: '#006644',
                fontWeight: 700,
                backgroundColor: '#E3FCEF',
                padding: '3px 8px',
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
                fontFamily: 'Poppins',
              },
            },
          }] : null,
        },
        series: [
          {
            type: 'column',
            color: '#397151',
            borderColor: '#397151',
            name: 'Hardware Installs',
            data: this.hardwareAxis,
            stack: 'install',
          }, {
            type: 'column',
            color: '#66D383',
            borderColor: '#66D383',
            name: 'Verified Installs',
            data: this.verifiedAxis,
            stack: 'install',
          },
          {
            type: 'column',
            color: '#2A448E',
            borderColor: '#2A448E',
            name: 'Member Purchases',
            data: this.customerPurchasesAxis,
            stack: 'sold',
          },
        ],
      };
    },
    graphHardwareInstallsValues() {
      if (this.activeFilter === '1month') {
        const weekData = {};
        this.graphHardwareInstallsData.forEach(({ date, count, week }, idx) => {
          if (!weekData[week]) {
            weekData[week] = {
              date,
              counts: [count],
            };
            if ((weekData[week - 1]) && this.graphHardwareInstallsData[idx - 1]) {
              weekData[week - 1].date = this.graphHardwareInstallsData[idx - 1].date;
            }
          } else if (weekData[week]) {
            weekData[week].counts.push(count);
          }
        });
        if (Object.keys(weekData).length > 4) {
          const iterations = Object.keys(weekData).length - 4;
          for (let i = 0; i < iterations; i += 1) {
            const min = i + 1;
            delete weekData[Object.keys(weekData)[Object.keys(weekData).length - min]];
          }
        }
        if (weekData) {
          return Object.values(weekData).map(({ date, counts }) => ({
            date,
            count: counts.reduce((a, b) => a + b, 0),
          }));
        }
      }
      if (this.activeFilter === '3months' || this.activeFilter === '9months') {
        const monthData = {};
        this.graphHardwareInstallsData.forEach(({
          date, count, month, year,
        }) => {
          const key = `${month}-${year}`;
          if (!monthData[key]) {
            monthData[key] = {
              date,
              counts: [count],
            };
          } else if (monthData[key]) {
            monthData[key].date = date;
            monthData[key].counts.push(count);
          }
        });
        const diff = this.activeFilter === '3months' ? 3 : 9;
        // if there are more than 3/9 months divided up return the first 3/9
        if (Object.keys(monthData).length > diff) {
          const iterations = Object.keys(monthData).length - diff;
          for (let i = 0; i < iterations; i += 1) {
            const min = i + 1;
            delete monthData[Object.keys(monthData)[Object.keys(monthData).length - min]];
          }
          // if the last obj is today, and there are less than 14 days
        } else if (Object.keys(monthData).length == diff && moment(monthData[Object.keys(monthData)[Object.keys(monthData).length - 1]].date).isSame(moment(), 'day') && monthData[Object.keys(monthData)[Object.keys(monthData).length - 1]].counts.length < 14) {
          // delete today
          delete monthData[Object.keys(monthData)[Object.keys(monthData).length - 1]];
          // push month  before first,  zero w/ counts
          const monthBeforeFirst = moment(monthData[Object.keys(monthData)[0]].date).subtract(1, 'months').format('YYYY-MM-DD');
          monthData[Object.keys(monthData)[0] - 1] = {
            date: monthBeforeFirst,
            counts: [0],
          };
        }
        const data = Object.values(monthData).map(({ date, counts }) => ({
          date,
          count: counts.reduce((a, b) => a + b, 0),
        }));
        data.sort((a, b) => new Date(a.date) - new Date(b.date));
        return data;
      }
      return this.graphHardwareInstallsData;
    },
    graphVerifiedInstallsValues() {
      if (this.activeFilter === '1month') {
        const weekData = {};
        this.graphHardwareInstallsData.forEach(({ date, verifiedCount, week }, idx) => {
          if (!weekData[week]) {
            weekData[week] = {
              date,
              counts: [verifiedCount],
            };
            if ((weekData[week - 1]) && this.graphHardwareInstallsData[idx - 1]) {
              weekData[week - 1].date = this.graphHardwareInstallsData[idx - 1].date;
            }
          } else if (weekData[week]) {
            weekData[week].counts.push(verifiedCount);
          }
        });
        if (Object.keys(weekData).length > 4) {
          const iterations = Object.keys(weekData).length - 4;
          for (let i = 0; i < iterations; i += 1) {
            const min = i + 1;
            delete weekData[Object.keys(weekData)[Object.keys(weekData).length - min]];
          }
        }
        if (weekData) {
          return Object.values(weekData).map(({ date, counts }) => ({
            date,
            count: counts.reduce((a, b) => a + b, 0),
          }));
        }
      }
      if (this.activeFilter === '3months' || this.activeFilter === '9months') {
        const monthData = {};
        this.graphHardwareInstallsData.forEach(({
          date, verifiedCount, month, year,
        }) => {
          const key = `${month}-${year}`;
          if (!monthData[key]) {
            monthData[key] = {
              date,
              counts: [verifiedCount],
            };
          } else if (monthData[key]) {
            monthData[key].date = date;
            monthData[key].counts.push(verifiedCount);
          }
        });
        const diff = this.activeFilter === '3months' ? 3 : 9;

        if (Object.keys(monthData).length > diff) {
          const iterations = Object.keys(monthData).length - diff;
          for (let i = 0; i < iterations; i += 1) {
            const min = i + 1;
            delete monthData[Object.keys(monthData)[Object.keys(monthData).length - min]];
          }
        } else if (Object.keys(monthData).length == diff && moment(monthData[Object.keys(monthData)[Object.keys(monthData).length - 1]].date).isSame(moment(), 'day') && monthData[Object.keys(monthData)[Object.keys(monthData).length - 1]].counts.length < 14) {
          // delete today
          delete monthData[Object.keys(monthData)[Object.keys(monthData).length - 1]];
          // push month  before first,  zero w/ counts
          const monthBeforeFirst = moment(monthData[Object.keys(monthData)[0]].date).subtract(1, 'months').format('YYYY-MM-DD');
          monthData[Object.keys(monthData)[0] - 1] = {
            date: monthBeforeFirst,
            counts: [0],
          };
        }
        if (monthData) {
          const data = Object.values(monthData).map(({ date, counts }) => ({
            date,
            count: counts.reduce((a, b) => a + b, 0),
          }));
          data.sort((a, b) => new Date(a.date) - new Date(b.date));
          return data;
        }
      }
      return this.graphHardwareInstallsData.map(({ date, verifiedCount }) => ({
        date,
        count: verifiedCount,
      }));
    },
    graphCustomerPurchasesValues() {
      if (this.activeFilter === '1month') {
        const weekData = {};
        this.graphHardwareInstallsData.forEach(({ date, purchaseCount, week }, idx) => {
          if (!weekData[week]) {
            weekData[week] = {
              date,
              counts: [purchaseCount],
            };
            if ((weekData[week - 1]) && this.graphHardwareInstallsData[idx - 1]) {
              weekData[week - 1].date = this.graphHardwareInstallsData[idx - 1].date;
            }
          } else if (weekData[week]) {
            weekData[week].counts.push(purchaseCount);
          }
        });
        if (Object.keys(weekData).length > 4) {
          const iterations = Object.keys(weekData).length - 4;
          for (let i = 0; i < iterations; i += 1) {
            const min = i + 1;
            delete weekData[Object.keys(weekData)[Object.keys(weekData).length - min]];
          }
        }
        if (weekData) {
          return Object.values(weekData).map(({ date, counts }) => ({
            date,
            count: counts.reduce((a, b) => a + b, 0),
          }));
        }
      }
      if (this.activeFilter === '3months' || this.activeFilter === '9months') {
        const monthData = {};
        this.graphHardwareInstallsData.forEach(({
          date, purchaseCount, month, year,
        }) => {
          const key = `${month}-${year}`;
          if (!monthData[key]) {
            monthData[key] = {
              date,
              counts: [purchaseCount],
            };
          } else if (monthData[key]) {
            monthData[key].date = date;
            monthData[key].counts.push(purchaseCount);
          }
        });
        const diff = this.activeFilter === '3months' ? 3 : 9;
        // if (Object.keys(monthData).length > diff) {
        //   const iterations = Object.keys(monthData).length - diff;
        //   for (let i = 0; i < iterations; i += 1) {
        //     delete monthData[Object.keys(monthData)[i]];
        //   }
        // }
        if (Object.keys(monthData).length > diff) {
          const iterations = Object.keys(monthData).length - diff;
          for (let i = 0; i < iterations; i += 1) {
            const min = i + 1;
            delete monthData[Object.keys(monthData)[Object.keys(monthData).length - min]];
          }
        } else if (Object.keys(monthData).length == diff && moment(monthData[Object.keys(monthData)[Object.keys(monthData).length - 1]].date).isSame(moment(), 'day') && monthData[Object.keys(monthData)[Object.keys(monthData).length - 1]].counts.length < 14) {
          // delete today
          delete monthData[Object.keys(monthData)[Object.keys(monthData).length - 1]];
          // push month  before first,  zero w/ counts
          const monthBeforeFirst = moment(monthData[Object.keys(monthData)[0]].date).subtract(1, 'months').format('YYYY-MM-DD');
          monthData[Object.keys(monthData)[0] - 1] = {
            date: monthBeforeFirst,
            counts: [0],
          };
        }
        if (monthData) {
          const data = Object.values(monthData).map(({ date, counts }) => ({
            date,
            count: counts.reduce((a, b) => a + b, 0),
          }));
          data.sort((a, b) => new Date(a.date) - new Date(b.date));
          return data;
        }
      }
      return this.graphHardwareInstallsData.map(({ date, purchaseCount }) => ({
        date,
        count: purchaseCount,
      }));
    },
    hardwareAxis() {
      const hardwareCounts = this.graphHardwareInstallsValues.map(({ count }) => count);
      const sum = hardwareCounts.reduce((a, b) => a + b, 0);
      if (sum > 0) {
        return hardwareCounts;
      }
      return [];
    },
    verifiedAxis() {
      const verifiedCounts = this.graphVerifiedInstallsValues.map(({ count }) => count);
      const sum = verifiedCounts.reduce((a, b) => a + b, 0);
      if (sum > 0) {
        return verifiedCounts;
      }
      return [];
    },
    customerPurchasesAxis() {
      const purchases = this.graphCustomerPurchasesValues.map(({ count }) => count);
      const sum = purchases.reduce((a, b) => a + b, 0);
      if (sum > 0) {
        return purchases;
      }
      return [];
    },
    customRangeHeader() {
      const {
        start,
        end,
      } = this.customRange;

      const {
        dateFormat,
      } = this;

      if (start && end) {
        let startFormat = dateFormat === 'M/D' ? 'MMM D' : 'D MMM';
        if (!moment(start).isSame(end, 'year')) {
          startFormat = dateFormat === 'M/D' ? 'MMM D \'YY' : 'D MMM \'YY';
        }
        const endFormat = dateFormat === 'M/D' ? 'MMM D \'YY' : 'D MMM \'YY';
        const rangeStart = moment(start).format(startFormat);
        const rangeEnd = moment(end).format(endFormat);
        return `${rangeStart} - ${rangeEnd}`;
      }
      return null;
    },
    isThereData() {
      const sumOfHardwareAxis = this.hardwareAxis.reduce((a, b) => a + b, 0);
      const sumofCustoAxis = this.customerPurchasesAxis.reduce((a, b) => a + b, 0);
      const sumOfVerifiedAxis = this.verifiedAxis.reduce((a, b) => a + b, 0);
      if (
        ((sumOfHardwareAxis === 0 && this.hardwareAxis.length > 0)
        && (sumofCustoAxis === 0 && this.customerPurchasesAxis.length > 0)
        && (sumOfVerifiedAxis === 0 && this.verifiedAxis.length > 0))
        || (this.hardwareAxis.length === 0 && this.verifiedAxis.length === 0 && this.customerPurchasesAxis.length === 0)) {
        return true;
      }
      return false;
    },
  },
  watch: {
    activeFilter() {
      this.getHardwareInstallGraph();
    },
    selectedCorpId() {
      this.getHardwareInstallGraph();
      this.getInstallationTarget();
    },
    selectedTech() {
      this.getHardwareInstallGraph();
      this.getInstallationTarget();
    },
  },
  mounted() {
    document.querySelector(':not(.target-popup-container)').addEventListener('click', this.closeOnClick);
    if (this.selectedTech) {
      this.getHardwareInstallGraph();
      this.getInstallationTarget();
    }
  },
  destroyed() {
    document.querySelector(':not(.target-popup-container)').removeEventListener('click', this.closeOnClick);
  },
  methods: {
    closeOnClick(e) {
      if (!e.target.closest('.target-container') && !e.target.closest('.target-popup-container') && this.showTargets) {
        this.showTargets = false;
        this.focused = '';
      }
    },
    getCorpId() {
      let corpId;
      corpId = this.$store.state.admin.adminFilter.corpId;
      if (!corpId || corpId < 0 || this.selectedTech.corporationId !== corpId) {
        corpId = this.selectedTech.corporationId;
      }
      return corpId;
    },
    async getInstallationTarget() {
      const corpId = this.getCorpId();
      if (corpId > 0) {
        const { data: settings } = await apiClient({
          method: 'GET',
          url: `/partner/settings/${corpId}`,
        });
        if (settings.INSTALLATION_TARGET) {
          this.teamCopy = settings.INSTALLATION_TARGET;
          this.teamTarget = settings.INSTALLATION_TARGET;
        }
        if (settings.INDIVIDUAL_TECH_TARGET) {
          this.installationTarget = settings.INDIVIDUAL_TECH_TARGET;
          this.installationCopy = settings.INDIVIDUAL_TECH_TARGET;
        }
      }
    },
    toggleTargetPopover(show) {
      this.showTargets = show;
    },
    async saveInstallationTarget(targetType) {
      let settingName;
      let settingValue;
      if (targetType === 'team') {
        settingName = 'INSTALLATION_TARGET';
        settingValue = this.teamCopy;
        this.teamTarget = this.teamCopy;
      } else {
        settingName = 'INDIVIDUAL_TECH_TARGET';
        settingValue = this.installationCopy;
        this.installationTarget = this.installationCopy;
      }
      try {
        const updateSettings = [{
          settingName,
          settingValue,
          corpId: this.getCorpId(),
        }];
        await apiClient({
          method: 'POST',
          url: '/partner/settings/set',
          data: updateSettings,
        });
        if (settingValue) {
          this.$store.dispatch('showSuccessToast', {
            message: `Installation target was updated to ${settingValue}`,
          });
        } else {
          this.$store.dispatch('showSuccessToast', {
            message: 'Installation target was updated',
          });
        }
        this.showTargets = false;
      } catch (err) {
        this.$store.dispatch('showAlertToast', {
          message: 'There was an unexpected error updating installation target. Please try again or contact support',
        });
      }
    },
    cancelInstallionTarget(targetType) {
      // this.installationCopy = this.installationTarget;
      if (targetType === 'team') {
        this.teamCopy = 0;
      } else {
        this.installationCopy = 0;
      }
      this.saveInstallationTarget(targetType);
      this.focused = '';
      this.showTargets = false;
    },
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault();
      } else {
        return true;
      }
      return true;
    },
    async getHardwareInstallGraph() {
      const {
        start,
        end,
      } = this.customRange;
      this.loading = true;
      try {
        if (this.selectedTech.id) {
          let url = `/adoption/stat/cumulative/install/tech/${this.selectedTech.id}`;
          let queryParams = '?';
          let startQuery = null;
          let endQuery = moment().format('YYYY-MM-DD');
          if (this.activeFilter === '1month') {
            startQuery = moment().subtract(4, 'weeks').format('YYYY-MM-DD');
          } else if (this.activeFilter === '3months') {
            startQuery = moment().subtract(3, 'months').format('YYYY-MM-DD');
          } else if (this.activeFilter === '9months') {
            startQuery = moment().subtract(9, 'months').format('YYYY-MM-DD');
          } else if (this.activeFilter === 'custom') {
            startQuery = moment(start).format('YYYY-MM-DD');
            endQuery = moment(end).format('YYYY-MM-DD');
          }
          if (startQuery) {
            queryParams += `start=${startQuery}&`;
          }
          queryParams += `end=${endQuery}`;
          url += queryParams;
          const { data } = await apiClient({
            method: 'GET',
            url,
          });
          this.graphHardwareInstallsData = data;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    changeDateFilter(date) {
      this.activeFilter = date;
      if (date !== 'custom') {
        this.customRange = {
          start: null,
          end: null,
        };
      }
    },
    clearRangeFilter() {
      this.customRange = {
        start: null,
        end: null,
      };
      this.activeFilter = '1month';
    },
  },
};
</script>

<style lang="scss">

.tech-cumulative-chart-container {
  position: relative;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    .header {
      font-size: 0.875rem;
      font-weight: 700;
      color: $WHITE;
      white-space: nowrap;
    }
  }
  .filter-container {
    display: flex;
    align-items: center;
    .goal-button {
      width: 74px;
      height: 22px;
      margin-left: 15px;
    }
    .filter-button {
      font-size: 0.875rem;
      font-weight: 500;
      color: $N60;
      text-decoration: underline;
      margin-left: 24px;
      display: flex;
      white-space: nowrap;
      align-items: center;
      &.active {
        font-weight: 700;
        color: $WHITE;
        text-decoration: none;
      }
      .button-icon {
        width: 12px;
        margin-left: 5px;
        object-fit: contain;
      }
      .clear-container {
        position: relative;
        &:hover {
          .clear-tooltip {
            opacity: 1;
          }
        }
        .clear-btn {
          display: flex;
        }
        .clear-tooltip {
          position: absolute;
          top: -20px;
          left: -26px;
          opacity: 0;
          background-color: $WHITE;
          color: $N100;
          font-size: 0.625rem;
          padding: 2px 4px;
          border-radius: 4px;
          white-space: nowrap;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
    .target-container {
      position: relative;

      .target-button {
        padding-top: 5px;

        .target-icon {
          width: 16px;
          height: 16px;
          object-fit: contain;
        }
      }

      .target-popup-container {
        position: absolute;
        background-color: $N10;
        z-index: 2;
        min-width: 315px;
        border-radius: 8px;
        padding: 16px 0;
        left: -120px;

        // .tp-header-container {
        //   display: flex;
        //   align-items: center;
        //   justify-content: start;

        //   .target-icon {
        //     width: 16px;
        //     height: 16px;
        //     object-fit: contain;
        //     margin-right: 8px;
        //   }

        //   .tp-header {
        //     font-weight: 700;
        //     color: $DETAILBLACK;
        //   }
        // }
        .target-icon {
            width: 16px;
            height: 16px;
            object-fit: contain;
            margin-right: 8px;
          }

        .tp-body-container {
          display: flex;
          align-items: center;
          margin-top: 18px;
          width: 100%;
          padding: 10px 0;
          padding-left: 20px;
          .tp-input {
            width: 40px;
            background-color: $E4;
            border-radius: 6px;
            height: 36px;
            padding-left: 10px;
            color: $WHITE;
            font-size: 1.125rem;
            &.active {
              background-color: $WHITE;
              color: $E4;
            }
          }
          &.active {
            background-color: $PRIMARY;
          }

          .tp-button {
            width: 24px;
            height: 24px;
            margin-left: 8px;
            .check-icon {
              width: 100%;
              height: 100%;
              // width: 24px;
              // height: 19px;
              object-fit: contain;
            }

            .x-icon {
              width: 100%;
              height: 100%;
            // width: 24px;
            // height: 24px;
              object-fit: contain;
            }
          }
        }
      }
    }
  }
  .loading-container {
    height: 300px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .no-data {
    position: absolute;
    z-index: 1;
    top: 45%;
    left: 25%;
    color: $WHITE;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
